export function checkAuthenticated() {
  return localStorage.getItem("authenticated") !== null;
}

interface User {
  adGroups: string[];
  createdAt: string;
  authProvider: string;
  lastSeenDate: string;
  railAuthGroups: string[];
  updatedAt: string;
  username: string;
  email: string;
  contactNo: string;
  fullName: string;
  status: string;
  isGroupOwner: boolean;
  statusUpdatedAt: string;
  memberOfGroupIds: string[];
  ownerOfGroupIds: string[];
  seenOnboardingScreens: string[];
  __v: number;
  _id: string;
}

export const useUser = () => {
  const user = localStorage.getItem("user");
  if (user) {
    const userObject: User = JSON.parse(user);
    return userObject;
  }
  return null;
};

export async function Logout() {
  localStorage.clear();
}
